<template>
  <div class="card col-md-6 mx-md-auto col-lg-3 px-0 ml-0">
    <div class="sombra mr-0 mr-md-3">
      <div
        class="card-header row mx-0 mt-0"
        :style="'background-color: ' + institucion.pantone +'; color: #FFF;'"
      >
        <AñoAcreditacion
          v-if="institucion.acreditado"
          :acreditacion="institucion.acreditacion"
          divClass="col-2 icon mr-3 px-0 text-center"
        />
        <div
          class="col-9 tit-instt px-0"
          v-b-tooltip.hover
          :title="institucion.nombre"
        >{{institucion.nombreCorto}}</div>
      </div>

      <div class="card-body">
        <div class="cabezal text-center">
          <h5 class="mt-3">{{limpiarNombreTipoInstitucion(institucion.tipoInstitucion)}}</h5>
          <p class="card-text text-muted">{{limpiarNombreRegion(institucion.region)}}</p>
          <h6 class="card-text mb-3">
            <a :href="institucion.web" target="_blank">Ver sitio web</a>
          </h6>
        </div>
        <!--<div class="row iconos">
          <Gratuidad
            :gratuidad="institucion.gratuidad"
            classDiv="row col-8 mx-auto justify-content-center align-items-center"
            styleImg="max-width: 32px;"
          />
        </div>-->
      </div>

      <div class="card-footer mx-0 mb-1 d-flex">
        <span
          @click="contactame"
          class="btn btn-secondary mr-auto"
          type="button"
          data-toggle="tooltip"
          title
          data-original-title="Solicita que te envíen más información sobre esta carrera"
        >
          <FontAwesomeIcon icon="envelope" class="mr-3" />
          <small>Contáctenme</small>
        </span>
      </div>

      <div class="card-footer mx-0 d-flex">
        <span
          class="btn btn-secondary mr-auto"
          type="button"
          v-b-tooltip.hover
          title="Ver más información sobre esta institución"
          @click="verFicha"
        >
          <FontAwesomeIcon icon="plus-circle" class="mr-3" />
          <small>Ver más</small>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import AñoAcreditacion from "@/components/generales/iconos/AñoAcreditacionBlanco";
import Gratuidad from "@/components/generales/iconos/Gratuidad";
import Busqueda from "@/utils/Busqueda.js";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faEnvelope, faPlusCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { ModalContacto, ModalContactoTP } from "@/utils/BusesDeEventos.js";
library.add(faEnvelope, faPlusCircle);
export default {
  name: "TarjetaInstitucion",
  props: {
    institucion: {
      type: Object
    },
    routerFicha: {
      type: String
    },
    origenRedirect: {
      type: String
    }
  },
  components: {
    AñoAcreditacion,
    Gratuidad,
    FontAwesomeIcon
  },
  methods: {
    limpiarNombreRegion(region) {
      return Busqueda.limpiarNombreRegionSimble(region);
    },
    limpiarNombreTipoInstitucion(texto) {
      return Busqueda.limpiarNombreTipoInstitucion(texto);
    },
    verFicha() {
      this.$router.push({
        name: this.routerFicha,
        params: {
          idInstitucion: this.institucion.id,
          origen: this.origenRedirect
        }
      });
    },
    contactame() {
      let datosContacto = {
        codigoIntitucion: this.institucion.codigo,
        codigoSede:
          this.institucion.listadoSedes.length === 1
            ? this.institucion.listadoSedes[0].codigoSede
            : null,
        listadoSedes:
          this.institucion.listadoSedes.length > 1
            ? this.institucion.listadoSedes
            : null
      };
      if (this.origenRedirect === "BuscadorIP") {
        ModalContactoTP.$emit("contactameTP", datosContacto);
      } else {
        ModalContacto.$emit("contactame", datosContacto);
      }
    }
  }
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/generales/tarjetas/TarjetaInstitucion.vue